import { Download, ExclamationTriangle } from 'assets/icons';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import Tooltip from 'components/common/Tooltip';
import Button from 'components/common/Button';
import { useQuery } from '@apollo/client/react';
import { MyBudgetPdfDocument } from 'graphql/generated/graphql';
import s from './Downloads.module.scss';

interface IDownloadsProps {
  project: { pdf: string | null };
}

export default function Downloads({ project }: IDownloadsProps) {
  const { data: myBudgetQueryData } = useQuery(MyBudgetPdfDocument);
  const budgetPdfUrl = myBudgetQueryData?.myBudget?.pdf;
  const { formatMessage: t } = useIntl();

  return (
    <div className={s.downloads}>
      <h3 className="mt-0">{t({ id: 'dashboard.downloads.title' })}</h3>
      <a
        // React leaves out a null href, as it does an undefined one.
        href={project.pdf ?? undefined}
        target="_blank"
        rel="noopener noreferrer"
        className={cn('link', s.downloadButton)}
      >
        <Button startIcon={<Download />}>{t({ id: 'dashboard.downloads.project_pdf' })}</Button>
      </a>
      <Tooltip
        hide={Boolean(budgetPdfUrl)}
        placement="top"
        overlay={<p>{t({ id: 'dashboard.downloads.budget_not_available_tooltip' })}</p>}
      >
        <a
          href={budgetPdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={cn('link', s.downloadButton, !budgetPdfUrl && 'cursor-default')}
        >
          <Button startIcon={budgetPdfUrl ? <Download /> : <ExclamationTriangle />}>
            {t({ id: 'dashboard.downloads.budget_pdf' })}
          </Button>
        </a>
      </Tooltip>
    </div>
  );
}
